import { TextField } from "@mui/material";

// Same box as the editable fields, but it never highlights, so it does not read as editable.
export const ReadOnlyField = ({
	label,
	value,
	numeric = false,
}: {
	label: string;
	value: string | null | undefined;
	numeric?: boolean;
}) => (
	<TextField
		label={label}
		value={value || "-"}
		fullWidth
		size="small"
		slotProps={{
			inputLabel: { shrink: true },
			input: { readOnly: true },
			htmlInput: {
				tabIndex: -1,
				style: numeric
					? { textAlign: "right", fontVariantNumeric: "tabular-nums" }
					: undefined,
			},
		}}
		sx={{
			"& .MuiOutlinedInput-root": {
				bgcolor: "action.hover",
				"& fieldset": { borderColor: "divider", borderWidth: 1 },
				"&:hover fieldset": { borderColor: "divider", borderWidth: 1 },
				"&.Mui-focused fieldset": { borderColor: "divider", borderWidth: 1 },
			},
			"& .MuiInputBase-input": { cursor: "default", color: "text.secondary" },
		}}
	/>
);
